<script setup lang="ts">
const route = useRoute();
const isSticky = ref(false);
const isMenuOpen = ref(false);
const appUserStore = useAppUserStore();

const handleScroll = () => {
	isSticky.value = window.scrollY > 100;
};

const toggleMenu = () => {
	isMenuOpen.value = !isMenuOpen.value;
};

onMounted(() => {
	window.addEventListener("scroll", handleScroll);
	handleScroll();
});

onUnmounted(() => {
	window.removeEventListener("scroll", handleScroll);
});

// Définir les boutons avec les rôles associés
const buttons = [
	{ icon: "home", link: "/", role: "MyIfen-User" },
	{ text: "Mon profil", link: "/profil", role: "MyIfen-User" },
	{ text: "Mon espace participant", link: "/participant/inscriptions", role: "MyIfen-Participant" },
	{ text: "Mon espace formateur", link: "/formateur/prestations", role: "MyIfen-Formateur" },
	{ text: "Mon espace délégué à la formation", link: "/delegue/prestations", role: "MyIfen-Delegue" },
	{ text: "Mon calendrier", link: "/calendrier", role: "MyIfen-User" },
];

const userButtons = computed(() => {
	return buttons.filter(button => appUserStore.currentUser?.roles.includes(button.role));
});

const isActiveButton = (button: { icon?: string; text?: string; link: string; role: string }): boolean => {
	return button.link === route.path
		|| (button.link === "/participant/inscriptions" && route.path.startsWith("/participant/"))
		|| (button.link === "/formateur/prestations" && route.path.startsWith("/formateur/"))
		|| (button.link === "/delegue/prestations" && route.path.startsWith("/delegue/"));
};

const activeButton = computed(() => {
	const active = userButtons.value.find(button => isActiveButton(button));
	return active ? active.text : "Menu";
});

const filteredButtons = computed(() => {
	return userButtons.value.filter(button => button.link !== route.path);
});

const devProxyParam = computed(() => document.location.host.includes("localhost") ? `&devProxy=${encodeURIComponent(document.location.protocol + "//" + document.location.host)}` : "");
const logoutUrl = computed(() => `/ifen/my/api/logout?returnUrl=/ifen/my/${devProxyParam.value}`);
</script>

<template>
	<div :class="['nav-button', { sticky: isSticky }]">
		<NuxtLink v-for="(button, index) in userButtons"
			:key="index"
			:to="button.link"
			class="nav-button-item"
			:class="{
				'active': isActiveButton(button),
				'icon-button': button.icon === 'home',
			}">
			<template v-if="button.icon">
				<img v-if="button.icon === 'home'"
					src="/img/pictos/header/picto_home.svg"
					alt="Picto Home" />
			</template>
			<template v-else>
				{{ button.text }}
			</template>
		</NuxtLink>
		<div class="nav-button-item icon-button logout">
			<NuxtLink :href="logoutUrl"
				external>
				<span>{{ appUserStore.currentUser?.iam }}</span>
				<div class="icon-button-logout">
					<img src="/img/pictos/header/picto_logout_red.svg"
						alt="Picto Logout" />
				</div>

			</NuxtLink>
		</div>
	</div>

	<!-- Mobile Menu -->
	<div class="mobile-menu">
		<div class="mobile-menu-icons">
			<NuxtLink :to="'/'"
				class="icon-button">
				<img src="/img/pictos/header/picto_home.svg"
					alt="Picto Home" />
			</NuxtLink>
			<button class="mobile-menu-trigger"
				@click="toggleMenu">
				{{ activeButton }}
				<img src="/img/pictos/header/chevron_up.svg"
					alt="Picto chevron" />
			</button>
			<NuxtLink :href="logoutUrl"
				external
				class="icon-button logout">
				<img src="/img/pictos/header/picto_logout.svg"
					alt="Picto Logout" />
			</NuxtLink>
		</div>
		<div v-if="isMenuOpen"
			class="mobile-menu-list">
			<template v-for="(button, index) in filteredButtons"
				:key="index">
				<NuxtLink v-if="!button.icon"
					:to="button.link"
					class="mobile-menu-item"
					@click="isMenuOpen = false">
					{{ button.text }}
				</NuxtLink>
			</template>
		</div>
	</div>
</template>
